module.exports = __webpack_public_path__ + "static/img/testlogin_back.1fd4a67d.gif";